import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { useCustomerPreview } from 'hooks/use-customer-preview';
import { Divider, Heading } from '../authenticate.styles';
import { DisconnectedProps } from './disconnected.types';

export const Disconnected = ({ oauthUrl }: DisconnectedProps) => {
  const { isPreview } = useCustomerPreview();

  return (
    <>
      <Heading>
        <FormattedMessage id="settings.integrations.slack.authenticate.title" />
      </Heading>
      <Button
        type="primary"
        icon={<ArrowRight16 />}
        iconPlacement="right"
        href={oauthUrl}
        disabled={isEmpty(oauthUrl) || !!isPreview}
      >
        <FormattedMessage id="settings.integrations.slack.authenticate.connect" />
      </Button>
      <Divider />
    </>
  );
};
